
import { ButtonGroup } from '@material-ui/core';
import React, { Fragment } from 'react';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';
import { ArcaRedirect } from '../../code/ArcaRedirect';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaLink } from '../controls/Fields/ArcaLink';
import { EmailViewPanel } from '../controls/Messaging/EmailViewPanel';
import { PageEditorPanel } from '../controls/PageDetails/PageEditorPanel';
import { ChangeLogPanel } from '../controls/People/ChangeLogPanel';
import { InvoiceListByTypePanel } from '../controls/People/InvoiceListByTypePanel';
import { Stats2Panel } from '../controls/People/Stats2Panel';
import { StatsPanel } from '../controls/People/StatsPanel';
import { PhotoMultiUpload } from '../controls/PhotoPanel/PhotoMultiUpload';
import { ModifierPanel } from '../controls/PriceMangement/ModifierPanel';
import { PricePanel } from '../controls/PriceMangement/PricePanel';
import { LoginPanel } from '../controls/Security/LoginPanel';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';
import { GroupEditor2 } from './Groups/GroupEditor2';
import { Logging } from './Logging';

export class Admin extends ArcaComponent {

    constructor(props) {
        super(props);

        ArcaRedirect.History = this.props.history;

        this.state = {
            tab: 'Prices',
            showButtonText: true,
            showButtonImage: !ArcaHttpSystem.IsSmartphone,
            widthWide: ArcaHttpSystem.IsSmartphone ? '80px' : '150px',
            isLoggedOn: ArcaSecurity.IsLoggedIn
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize() {
        this.setState({
            showButtonText: true,
            showButtonImage: !ArcaHttpSystem.IsSmartphone
        });
    }

    /*eslint-disable */
    render() {
        let { tab, widthWide, isLoggedOn } = this.state

        return (
            <div>
                {!isLoggedOn
                    ? <LoginPanel onLogon={(() => this.setState({ isLoggedOn: ArcaSecurity.IsLoggedIn }))} />
                    : <Fragment>
                        {ArcaSecurity.IsAdmin
                            ? <span className='center'>

                                <div className='centerText'>
                                    <ButtonGroup className='buttonGroup'>
                                        <ArcaLink
                                            text='Prices'
                                            width={widthWide}
                                            onClick={() => this.setState({ tab: 'Prices' })} />

                                        <ArcaLink text='Mods' width={widthWide} onClick={() => this.setState({ tab: 'Modifiers' })} />
                                        <ArcaLink text='Logs' width={widthWide} onClick={() => this.setState({ tab: 'Logging' })} />
                                        <ArcaLink text='Emails' width={widthWide} onClick={() => this.setState({ tab: 'Emails' })} />
                                    </ButtonGroup>
                                    <ButtonGroup className='buttonGroup'>
                                        <ArcaLink text='Pages' width={widthWide} onClick={() => this.setState({ tab: 'Pages' })} />
                                        <ArcaLink text='Group' width={widthWide} onClick={() => this.setState({ tab: 'Groups' })} />
                                        <ArcaLink text='Invs' width={widthWide} onClick={() => this.setState({ tab: 'Invoices' })} />
                                        <ArcaLink text='Change' width={widthWide} onClick={() => this.setState({ tab: 'ChangeLog' })} />
                                    </ButtonGroup>
                                    <ButtonGroup className='buttonGroup'>
                                        <ArcaLink text='Photos' width={widthWide} onClick={() => this.setState({ tab: 'Photos' })} />
                                        <ArcaLink text='Stats' width={widthWide} onClick={() => this.setState({ tab: 'Stats' })} />
                                        <ArcaLink text='Stats2' width={widthWide} onClick={() => this.setState({ tab: 'Stats2' })} />
                                    </ButtonGroup>

                                </div>
                                {tab === 'Prices' ? <PricePanel /> : null}
                                {tab === 'Modifiers' ? <ModifierPanel /> : null}
                                {tab === 'Logging' ? <Logging /> : null}
                                {tab === 'Emails' ? <EmailViewPanel /> : null}
                                {tab === 'Photos' ? <PhotoMultiUpload folder='Photos' id='0'/> : null}
                                {tab === 'Groups' ? <GroupEditor2 /> : null}
                                {tab === 'Pages' ? <PageEditorPanel /> : null}
                                {tab === 'Invoices' ? <InvoiceListByTypePanel /> : null}
                                {tab === 'ChangeLog' ? <ChangeLogPanel /> : null}
                                {tab === 'Stats' ? <StatsPanel /> : null}
                                {tab === 'Stats2' ? <Stats2Panel /> : null}

                                <hr />
                                <h2>Links</h2>
                                <a target="_blank" href='https://arca-webapp-dev-web-wa.azurewebsites.net/'>Developer</a>
                                |<a target="_blank" href='https://arca-webapp-test-web-wa.azurewebsites.net/'>Test</a>
                                |<a target="_blank" href='https://arca-webapp-live-web-wa.azurewebsites.net/'>Live</a>

                                <StatusBar isError={this.state.isError} message={this.state.statusText} />
                            </span >
                            : <span>
                                <h1 className='centerText'>Access denied!</h1>
                            </span>}
                    </Fragment>
                }
            </div>
        );
    }
}
